import { yup } from '@medely/ui-kit';

export const schedulingPreferencesSchema = yup.object({
  labels: yup.array().of(yup.string()),
  workdays: yup.array().of(yup.string()),
  positions: yup.array().of(yup.string()),
  preferred_weekly_total_shifts: yup.number(),
});
